/**
 * Full-screen fallback when a chunk/asset load error is detected (e.g. Disable cache → 404 chunk).
 * Subscribes to bootDebugStore.chunkErrors; when count > 0 shows "Có lỗi khi tải tài nguyên" + reload.
 * Optional: auto reload once after 800ms when first chunk error is detected.
 */
import { useEffect, useRef, useState } from 'react';
import { getBootDebugState, subscribeBootDebug } from '@/lib/bootDebugStore';

const CHUNK_AUTO_RELOAD_MS = 800;

export function ChunkErrorFallback() {
  const [chunkErrorCount, setChunkErrorCount] = useState(() => getBootDebugState().chunkErrors.count);
  const autoReloadDoneRef = useRef(false);

  useEffect(() => {
    return subscribeBootDebug(() => {
      setChunkErrorCount(getBootDebugState().chunkErrors.count);
    });
  }, []);

  useEffect(() => {
    if (chunkErrorCount === 0) return;
    if (autoReloadDoneRef.current) return;
    autoReloadDoneRef.current = true;
    const t = window.setTimeout(() => {
      window.location.reload();
    }, CHUNK_AUTO_RELOAD_MS);
    return () => window.clearTimeout(t);
  }, [chunkErrorCount]);

  if (chunkErrorCount === 0) return null;

  const state = getBootDebugState();
  return (
    <div className="fixed inset-0 z-[10000] flex flex-col items-center justify-center gap-4 bg-background p-4">
      <div className="flex max-w-md flex-col items-center gap-3 rounded-lg border border-border bg-muted/30 p-6 text-center">
        <p className="text-sm font-medium text-foreground">
          Có lỗi khi tải tài nguyên (có thể do bản build mới). Vui lòng bấm Tải lại.
        </p>
        {state.chunkErrors.lastMessage && (
          <p className="text-xs text-muted-foreground break-all">{state.chunkErrors.lastMessage.slice(0, 120)}</p>
        )}
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
        >
          Tải lại
        </button>
      </div>
    </div>
  );
}
